import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export default function Breadcrumbs({ items = [] }) {
  return (
    <nav className="text-xs sm:text-sm text-slate-500 flex items-center flex-wrap gap-1 mb-4" data-testid="breadcrumbs">
      <Link to="/" className="hover:text-[#1E3A8A] flex items-center gap-1"><Home size={12} /> Home</Link>
      {items.map((it, i) => (
        <span key={i} className="flex items-center gap-1">
          <ChevronRight size={12} />
          {it.to ? <Link to={it.to} className="hover:text-[#1E3A8A]">{it.label}</Link> : <span className="text-slate-800 font-semibold">{it.label}</span>}
        </span>
      ))}
    </nav>
  );
}
